// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "64cdecf",
    "hash": "64cdecf",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "64cdecf",
    "semverString": null,
    "timestamp": 1778385904888,
    "dateStr": "Sun May 10 2026 04:05:04 GMT+0000 (Coordinated Universal Time)"
};
